import { lazy, useEffect } from 'react';

// Full-page redirect helper used by the legacy ORGANIZATION.LANDING route.
// Keeping the redirect inside a useEffect keeps render side-effect-free —
// previously the assignment ran during render, which is forbidden by React
// and crashes under any non-DOM renderer (SSR).
export const FullPageRedirect = ({ to }: { to: string }) => {
   useEffect(() => {
      window.location.href = to;
   }, [to]);
   return null;
};

export const AccountDisabledPage = lazy(() => import('src/pages/user/disabled'));
export const BookingPage = lazy(() => import('src/pages/booking'));
export const HotelDetail = lazy(() => import('src/pages/hotel/hotelDetail'));
export const HotelGallery = lazy(() => import('src/pages/hotel/hotelGallery'));
export const HotelMapView = lazy(() => import('src/pages/hotel/hotelMapView'));
export const HotelSearch = lazy(() => import('src/pages/hotel/hotelSearch'));
export const LandingPage = lazy(() => import('src/pages/landing'));
export const LoginPage = lazy(() => import('src/pages/login'));
export const LogoutPage = lazy(() => import('src/pages/logout'));
export const NotFoundPage = lazy(() => import('src/pages/notFound'));
export const OrganizationLandingPage = lazy(() => import('src/pages/organization/landing'));
export const EventLandingPage = lazy(() => import('src/pages/event/landing'));
export const RegisterPage = lazy(() => import('src/pages/register'));
export const ClaimAccountPage = lazy(() => import('src/pages/claimAccount'));
export const SignupPage = lazy(() => import('src/pages/signup'));
export const UnauthorizedPage = lazy(() => import('src/pages/unauthorized'));
export const MyAccountPage = lazy(() => import('src/pages/user'));
export const MyFavoritesPage = lazy(() => import('src/pages/user/my-favorites'));

export const OrganizationPage = lazy(() => import('src/pages/admin/organization'));
export const AddEditOrganizationPage = lazy(() => import('src/pages/admin/organization/AddEdit'));
export const ManageTripsPage = lazy(() => import('src/pages/admin/manage-trips'));
export const TripDetailPage = lazy(() => import('src/pages/admin/manage-trips/Detail'));
export const ChangeStayPage = lazy(() => import('src/pages/user/my-trips/components/change/ChangeStayPage'));
export const AdminChangeStayPage = lazy(() =>
   import('src/pages/user/my-trips/components/change/ChangeStayPage').then(module => ({ default: module.AdminChangeStayPage })),
);
export const DisputesPage = lazy(() => import('src/pages/admin/disputes'));
export const FraudWatchPage = lazy(() => import('src/pages/admin/fraud-watch'));
export const FraudUserDetailPage = lazy(() => import('src/pages/admin/fraud-watch/UserDetail'));
export const ProgramSchedulePage = lazy(() => import('src/pages/admin/program-schedule'));
export const ProgramScheduleDetailPage = lazy(() => import('src/pages/admin/program-schedule/Detail'));
export const GameGuideEditorPage = lazy(() => import('src/pages/admin/program-schedule/game-guide'));
export const TeamHotelsPage = lazy(() => import('src/pages/admin/team-hotels'));
export const HotelCurationPage = lazy(() => import('src/pages/admin/hotel-curation'));
export const GameGuidePage = lazy(() => import('src/pages/game-guide'));
export const PlanSeasonPage = lazy(() => import('src/pages/plan-season'));
export const RolePage = lazy(() => import('src/pages/admin/role'));
export const TransactionPage = lazy(() => import('src/pages/admin/transaction'));
export const ProceedsReportPage = lazy(() => import('src/pages/admin/proceeds-report'));
// NPT-2144 — the org admin area.
export const OrgAdminHomePage = lazy(() => import('src/pages/admin/org-admin'));
export const OrgAdminTripsPage = lazy(() => import('src/pages/admin/org-admin/trips'));
export const OrgAdminUsersPage = lazy(() => import('src/pages/admin/org-admin/users'));
export const OrgAdminProceedsPage = lazy(() => import('src/pages/admin/org-admin/proceeds'));
export const UserPage = lazy(() => import('src/pages/admin/user'));
export const CouponPage = lazy(() => import('src/pages/admin/coupon'));
export const ReviewPage = lazy(() => import('src/pages/admin/review'));
export const HotelBlacklistPage = lazy(() => import('src/pages/admin/hotel-blacklist'));
export const Settings = lazy(() => import('src/pages/admin/settings'));
export const SiteConfigRegistry = lazy(() => import('src/pages/admin/site-config-registry'));
export const FontsPage = lazy(() => import('src/pages/admin/fonts'));
